// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"edit-off"},"nodeName":"g","children":[{"attributes":{"id":"fill2","fill":"transparent","d":"M17.9936 9.89339L21.0506 6.83635L17.1615 2.94727L14.1045 6.0043L17.9936 9.89339Z","fill-rule":"evenodd","clip-rule":"evenodd"},"nodeName":"path","children":[]},{"attributes":{"id":"stroke1","stroke":"currentColor","d":"M10.0545 10.0544L4.78744 15.3215L3.99805 20L8.67652 19.2106L13.9436 13.9435M12.6094 7.5L17.1622 2.94727L21.0513 6.83635L16.4985 11.3891M17.9946 9.89348L14.1055 6.00439","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]},{"attributes":{"id":"stroke2","stroke":"currentColor","d":"M4 4L10.0545 10.0545L13.9436 13.9436L20 20","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]}]}]};

@tag('t-icon-edit-off')
export default class EditOffIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'edit-off',
    }
  }
}
